// Importazione librerie React e componenti necessari
import { useState, useEffect } from "react";
import logo from "./assets/iren.png";
import logoTYR from "./assets/Logo TYR.png";
import logoDraill from "./assets/logo Draill scritta bianca su nero.png";
import { FaCheck, FaPhoneAlt } from "react-icons/fa";

const spinnerStyle = {
  display: "inline-block",
  width: "40px",
  height: "40px",
  border: "3px solid rgba(0, 0, 0, 0.3)",
  borderRadius: "50%",
  borderTopColor: "#4CAF50",
  animation: "spin 1s ease-in-out infinite",
};

const spinnerAnimation = `
@keyframes spin {
  to { transform: rotate(360deg); }

}
`;

//  const BASE_URL = "https://tyr.draill.com/api";
const BASE_URL = process.env.REACT_APP_API_BASE;

// fetch con gli headers giusti (dev/prod)
const fetchWithAuth = async (endpoint, options = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  // aggiungo x-proxy-auth manualmente in produzione
  if (process.env.NODE_ENV === "production") {
    headers["x-proxy-auth"] = process.env.REACT_APP_PROXY_AUTH;
  }

  const res = await fetch(`${BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  return res;
};

// Inietto animazione CSS nel file
const styleSheet = document.createElement("style");
styleSheet.innerText = spinnerAnimation;
document.head.appendChild(styleSheet);

function App() {
  const [step, setStep] = useState("view");
  const [otp, setOtp] = useState("");
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Stati per countdown e reinvio OTP
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [resendClicked, setResendClicked] = useState(0);

  // Stato per evitare richieste multiple di ricontatto
  const [contactRequestedOnce, setContactRequestedOnce] = useState(false);

  // Caricamento dati sessione al primo accesso
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");


    if (!sessionId) {
      setError("Manca session_id nell'URL");
      setLoading(false);
      return;
    }

      const fetchData = async () => {
        try {
          const res = await fetchWithAuth(`/ext/sessions/${sessionId}`);
          // console.log("GET /ext/sessions → status:", res.status);


        if (!res.ok) throw new Error(`Errore risposta API: ${res.status}`);
        const data = await res.json();
        //  console.log("GET /ext/sessions response:", data); // corpo risposta  

        // Controllo stato sessione
        if (data.session_status === "expired") {
          setError("⚠️ Il link è scaduto. Il nostro ufficio ti ricontatterà per completare la procedura.");
          return;
        }
        if (data.session_status === "confirmed") {
          setError("✔️ OTP già verificato per questa sessione. Nessuna azione necessaria.");
          return;
        }
        if (data.session_status === "requested_contact") {
          setError("📞 È già stata richiesta una richiamata per questa sessione.");
          return;
        }

        setSessionData(data);
      } catch (err) {
        // console.error("Errore finale:", err);
         setError(`Impossibile ottenere i dati dal server. (${err.message})`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);




// Invio OTP
const handleSendOtp = async () => {
  if (!sessionData?.session_id) return;

  // Blocca SOLO dal secondo reinvio in poi se timer > 0
  if (resendClicked > 1 && timer > 0) return;

  setLoading(true);
  setError("");
  try {
    const res = await fetchWithAuth("/ext/send-otp", {
      method: "POST",
      body: JSON.stringify({ session_id: sessionData.session_id }),
    });
    const data = await res.json();

    //Gestione errori dettagliata
    if (!res.ok) {
      let msg = "Impossibile inviare l'OTP. Riprova.";
      if (res.status === 400) msg = "Richiesta non valida.";
      if (res.status === 404) msg = "Sessione non trovata.";
      if (res.status === 429) msg = "Stai richiedendo troppi codici. Attendi qualche minuto.";
      if (res.status >= 500) msg = "Errore del server. Riprova tra poco.";
      throw new Error(msg);
    }

    alert("📩 OTP inviato al numero registrato.");
    setStep("otp");

    if (resendClicked === 0) {
      //Prima volta: avvio timer e mostro subito bottone attivo
      setTimer(120);
      setCanResend(true);
    } else {
      //Dal secondo reinvio: timer + bottone disabilitato
      setTimer(120);
    }

    setResendClicked((prev) => prev + 1);
  } catch (err) {
    // console.error("Errore invio OTP:", err);
    setError(err.message || "Errore sconosciuto durante l'invio OTP.");
  } finally {
    setLoading(false);
  }
};



  // Timer countdown
  useEffect(() => {
    if (timer <= 0) return;
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, [timer]);



  // Verifica OTP
  const handleVerifyOtp = async () => {
    if (!sessionData?.session_id || !otp) {
      setError("Inserisci il codice OTP.");
      return;
    }
    setLoading(true);
    setError("");

    try {
    const res = await fetchWithAuth("/ext/verify-otp", {
        method: "POST",
        body: JSON.stringify({ session_id: sessionData.session_id, otp }),
      });

      const data = await res.json();

      // Se OTP è errato mostro messaggio chiaro
      if (!res.ok) {
        if (res.status === 400) {
          setError("Il codice OTP inserito non è corretto. Riprova.");
        } else {
          setError(data.message || `Errore API: ${res.status}`);
        }
        setOtp(""); //  Pulisce automaticamente il campo
        document.getElementById("otp-input")?.focus(); // Riporta il focus nell'input
        return;
      }

      // alert("OTP verificato con successo!");
      setStep("done");
    } catch (err) {
      // console.error("Errore verifica OTP:", err);
      setError("Il codice OTP inserito non è valido. Riprova.");
      setOtp(""); // Pulisce anche qui
      document.getElementById("otp-input")?.focus();
    } finally {
      setLoading(false);
    }
  };



// Richiesta contatto (solo prima volta invia POST)
const handleRequestContact = async () => {
  if (!sessionData?.session_id) {
    setError("Sessione non trovata.");
    return;
  }

  if (contactRequestedOnce) {
    setError("📞 È già stata richiesta una richiamata per questa sessione.");
    return;
  }

  setLoading(true);
  setError("");
  try {
    const res = await fetchWithAuth("/ext/request-contact", {
      method: "POST",
      body: JSON.stringify({ session_id: sessionData.session_id }),
    });


    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.message || `Errore API: ${res.status}`);
    }

    const numeroOperatore = sessionData.outbound_telefono
      ? `+39 ${sessionData.outbound_telefono}`
      : "il nostro numero dedicato";

    // 1) POPUP
    alert(
      `Richiesta di ricontatto inviata con successo.\n` +
      `Sarai contattato a breve.\n` +
      `Ti invitiamo a salvare il numero ${numeroOperatore} per evitare blocchi da filtri antispam.`
    );

    setContactRequestedOnce(true);

    // 2) PASSA ALLA SCHERMATA DI CONFERMA
    setStep("contact_done");
    window.scrollTo({ top: 0, behavior: "smooth" });
  } catch (err) {
    // console.error("Errore richiesta contatto:", err);
    setError(err.message || "Impossibile inviare la richiesta di ricontatto.");
  } finally {
    setLoading(false);
  }
};



  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#ffffff",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div style={{ flex: 1, padding: 20, color: "#000" }}>
        <div style={{ textAlign: "center", marginBottom: 30 }}>
          <img src={logo} alt="Iren" style={{ height: 50 }} />
        </div>

        <div style={{ maxWidth: 420, margin: "0 auto" }}>
          {loading && (
            <div style={{ textAlign: "center", margin: "30px 0" }}>
              <div style={spinnerStyle}></div>
              <p style={{ color: "#444", marginTop: 10 }}>
                Caricamento dati in corso...
              </p>
            </div>
          )}



          {error && (
            <p
              style={{
                color: "#d9534f", 
                backgroundColor: "#fdecea", 
                fontSize: "12px",
                fontWeight: "400", 
                padding: "6px 10px",
                borderRadius: "5px",
                marginBottom: "8px",
                border: "1px solid #f5c6cb"
              }}
            >
              {error}
            </p>
          )}


          {/* Vista dati iniziale */}
          {!error && step === "view" && sessionData && (
            <>
              <h5 style={{ marginBottom: 20, color: "#222" }}>
                Gentile {sessionData?.nome || "-"} {sessionData?.cognome || "-"},
              </h5>
              <p style={{ fontSize: 11.5, color: "#222" }}>
                Per procedere con l’attivazione della tua nuova offerta del mercato libero sottoscritta con Iren Luce Gas e Servizi, ti chiediamo di verificare i dati relativi al tuo contratto di fornitura.
              </p>

              {/* Box dati */}
              <div
                style={{
                  background: "#f3f3f3",
                  padding: 10,
                  borderRadius: 10,
                  fontSize: "14px",
                  lineHeight: "1.6",
                  color: "#000",
                }}
              >
                <h5 style={{ margin: "5px 0 10px", color: "#eb840c"  }}>Dati Personali / Aziendali</h5>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Nome e Cognome:</strong> {sessionData?.nome} {sessionData?.cognome}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Ragione Sociale:</strong> {sessionData?.ragione_sociale}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Codice Fiscale / Partita IVA:</strong> {sessionData?.cf_piva}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Numero di Cellulare:</strong> {sessionData?.telefono}</p>

                <h5 style={{margin: "20px 0 0 0", color: "#e01419"  }}>Dettagli Contratto</h5>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Codice Contratto:</strong> {sessionData?.codice_contratto}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Tipo Operazione:</strong> {sessionData?.azione_comm}</p>

                <h5 style={{margin: "20px 0 0 0", color: "#225c94"  }}>Offerte Sottoscritte</h5>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Offerta Energia Elettrica:</strong> {sessionData?.nome_offerta_ele}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Offerta Gas:</strong> {sessionData?.nome_offerta_gas}</p>

                <h5 style={{margin: "20px 0 0 0", color: "#00973b"  }}>Punto di Fornitura</h5>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Codice POD:</strong> {sessionData?.codice_pod}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Codice PDR:</strong> {sessionData?.codice_pdr}</p>
                <p style={{ fontSize: 12, color: "#222" }}><strong>Provincia:</strong> {sessionData?.provincia_punto_di_fornitura}</p>
              </div>
            
              <button
                onClick={handleSendOtp}
                style={{
                  width: "100%",
                  padding: 10,
                  marginTop: 20,
                  marginBottom: 10,
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: 5,
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                <FaCheck size={17} />
                CONFERMA OFFERTA
              </button>

              <button
                onClick={handleRequestContact}
                disabled={loading}
                style={{
                  width: "100%",
                  padding: 10,
                  backgroundColor: loading ? "#ccc" : "#FFD700",
                  cursor: loading ? "not-allowed" : "pointer",
                  color: "black",
                  border: "none",
                  borderRadius: 5,
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  fontWeight: "bold",
                }}
              >
                <FaPhoneAlt />
                {loading ? "INVIO IN CORSO..." : "RICHIAMAMI"}
              </button>
            </>
          )}

          {/* Step inserimento OTP */}
          {step === "otp" && (
            <>
              <h4 style={{ marginBottom: 10, color: "#222" }}>Verifica dell’identità</h4>
              <p style={{ fontSize: "12px", marginBottom: 15, color: "#444" }}>
                Inserisci qui sotto il codice ricevuto via SMS.
              </p>
              <input
                type="text"
                placeholder="Scrivi il codice"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={{
                  width: "70%",
                  padding: 10,
                  marginBottom: 5,
                  borderRadius: 5,
                  border: "1px solid #ccc",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  textAlign: "center",
                  fontSize: "15px",
                }}
              />

              <button
                onClick={handleVerifyOtp}
                style={{
                  width: "75%",
                  padding: 10,
                  backgroundColor: "#2196F3",
                  color: "white",
                  border: "none",
                  borderRadius: 5,
                  marginBottom: 10,
                  cursor: "pointer"
                }}
              >
                INVIA
              </button>

              {/* Countdown */}
              {timer > 0 && (
                <p style={{ fontSize: "12px", color: "#444" }}>
                  🕓 Tempo rimanente: {Math.floor(timer / 60)}:{("0" + (timer % 60)).slice(-2)} min
                </p>
              )}


              {/* Pulsante reinvio codice */}
              {canResend && (
                <button
                  onClick={handleSendOtp}
                  // Alla prima volta è sempre cliccabile
                  // Dal secondo clic in poi è disabilitato finché il timer > 0
                  disabled={resendClicked > 1 && timer > 0}
                  style={{
                    width: "75%",
                    padding: 10,
                    backgroundColor: resendClicked > 1 && timer > 0 ? "#ccc" : "#f39c12",
                    cursor: resendClicked > 1 && timer > 0 ? "not-allowed" : "pointer",
                    color: "white",
                    border: "none",
                    borderRadius: 5,
                    marginTop: 10,
                  }}
                >
                  Reinvia codice
                </button>

              )}

            </>
          )}



          {/* Step finale */}
          {step === "done" && (
            <>
              <h4 style={{ color: "#4CAF50", margin:"1" }}>Documento firmato con successo!</h4>
              <p style={{ fontSize: 10, color: "gray", lineHeight: 1.6, marginTop: 2 }}><strong>Signed By: TYR powered by DRAILL (Need Care S.r.l.)</strong></p>
              <p style={{ fontSize: 12.5, color: "#222", lineHeight: 1.6, marginTop: 25 }}>
                Sarai contattato tra 24 ore dal nostro Ufficio Attivazione Clienti.
                Ti invitiamo a salvare il numero{" "}
                <strong>
                  {sessionData?.outbound_telefono
                    ? `+39 ${sessionData.outbound_telefono}`
                    : "il nostro numero dedicato"}
                </strong>{" "}
                per evitare i blocchi da filtri antispam.
                <br />
                <br />
                Non è richiesta alcuna azione da parte tua: puoi chiudere questa pagina in sicurezza.
              </p>
            </>
          )}


          {/* Step: conferma ricontatto */}
          {step === "contact_done" && (
            <>
              <h4 style={{ color: "#4CAF50", marginBottom: 8 }}>
                Richiesta di ricontatto inviata con successo
              </h4>
              <p style={{ fontSize: 12.5, color: "#222", lineHeight: 1.6 }}>
                Sarai contattato tra 24 ore dal nostro Ufficio Attivazione Clienti.
                Ti invitiamo a salvare il numero{" "}
                <strong>
                  {sessionData?.outbound_telefono
                    ? `+39 ${sessionData.outbound_telefono}`
                    : "il nostro numero dedicato"}
                </strong>{" "}
                per evitare i blocchi da filtri antispam.
                <br />
                <br />
                Non è richiesta alcuna azione da parte tua: puoi chiudere questa pagina in sicurezza.
              </p>
            </>
          )}


        </div>
      </div>

      <div
        style={{
          textAlign: "center",
          opacity: 0.6,
          paddingBottom: 0,
          paddingTop: 10,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <img src={logoTYR} alt="Logo TYR" style={{ height: 30 }} />
          <img src={logoDraill} alt="Logo DRAILL" style={{ height: 30 }} />
        </div>
        <p style={{ fontSize: 11, color: "#777", marginTop: 5 }}>
          Firma digitale certificata da <strong>TYR</strong> powered by <strong>DRAILL </strong>(Need Care S.r.l.)
        </p>
      </div>
    </div>
  );
}

export default App;




